/**
 * 转出 - 选择验证方式页面
 */

import { useCallback } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import PageLayout from '@/components/PageLayout'
import Header from '@/components/Header'
import Back from '@/components/Back'
import SelectVerification, { VerActionType } from '@/components/SelectVerification'

// 转出信息接口
interface WithdrawInfo {
  cardId: string
  cardNo: string
  amount: string
  currency: string
  receivedAmount: string
  fee: number
}

export default function WithdrawSelectVerification() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()

  // 从路由 state 获取转出信息
  const withdrawInfo: WithdrawInfo = location.state || {}

  // 验证方式选择成功回调
  const handleVerificationSuccess = useCallback((data: {
    actionType: VerActionType
    account: string
  }) => {
    // 跳转到验证码输入页面
    navigate('/card-v2/card-withdraw/verify-code', {
      state: {
        ...withdrawInfo,
        verificationMethod: data.actionType,
        account: data.account
      }
    })
  }, [navigate, withdrawInfo])

  return (
    <PageLayout>
      <Header
        leftChildren={<Back />}
      />

      <div className="flex-1 px-5 pt-6">
        <SelectVerification
          scene="card_withdraw"
          onSuccess={handleVerificationSuccess}
          showTitle={true}
          title={t('选择验证方式')}
        />
      </div>
    </PageLayout>
  )
}

